import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiChannel } from 'core/constants';

import { ModelBase } from '../../model-base';
import { buildHeaders, XmStore } from 'core/services';

import { StoreAction } from 'store/actions';
import { NowEsimActivation } from './models/activation';
import { NowEsimActivationStatus } from './models/activation-status';

@Injectable()
export class NowEsimActivationApi {
    public static getNowEsimActivationData(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<NowEsimActivation> {
        return http.post(`/now/mobile/activation/${params.lineId}`, {}, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: ApiResponse) => NowEsimActivation.create<NowEsimActivation>(response))
        );
    }

    public static getNowEsimActivationStatus(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<NowEsimActivationStatus> {
        return http.get(`/now/mobile/activation/status/${params.orderKey}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY  })
        }).pipe(
            map((response: NowEsimActivationStatus) => NowEsimActivationStatus.create<NowEsimActivationStatus>(response))
        );
    }
}

ModelBase.persistMapping[StoreAction.GET_NOW_ESIM_ACTIVATION] = NowEsimActivationApi.getNowEsimActivationData;
ModelBase.fetchMapping[StoreAction.GET_NOW_ESIM_ACTIVATION_STATUS] = NowEsimActivationApi.getNowEsimActivationStatus;
